var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationOn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1486_7761",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1486_7761)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0007 9.99999C10.459 9.99999 10.8513 9.8368 11.1777 9.51041C11.5041 9.18402 11.6673 8.79166 11.6673 8.33332C11.6673 7.87499 11.5041 7.48263 11.1777 7.15624C10.8513 6.82985 10.459 6.66666 10.0007 6.66666C9.54232 6.66666 9.14996 6.82985 8.82357 7.15624C8.49718 7.48263 8.33398 7.87499 8.33398 8.33332C8.33398 8.79166 8.49718 9.18402 8.82357 9.51041C9.14996 9.8368 9.54232 9.99999 10.0007 9.99999ZM10.0007 16.125C11.6951 14.5694 12.952 13.1562 13.7715 11.8854C14.5909 10.6146 15.0007 9.4861 15.0007 8.49999C15.0007 6.9861 14.518 5.74652 13.5527 4.78124C12.5875 3.81596 11.4034 3.33332 10.0007 3.33332C8.59787 3.33332 7.41385 3.81596 6.44857 4.78124C5.48329 5.74652 5.00065 6.9861 5.00065 8.49999C5.00065 9.4861 5.41037 10.6146 6.22982 11.8854C7.04926 13.1562 8.30621 14.5694 10.0007 16.125ZM10.0007 18.3333C7.76454 16.4305 6.0944 14.6632 4.99023 13.0312C3.88607 11.3993 3.33398 9.88888 3.33398 8.49999C3.33398 6.41666 4.00412 4.75693 5.3444 3.52082C6.68468 2.28471 8.23676 1.66666 10.0007 1.66666C11.7645 1.66666 13.3166 2.28471 14.6569 3.52082C15.9972 4.75693 16.6673 6.41666 16.6673 8.49999C16.6673 9.88888 16.1152 11.3993 15.0111 13.0312C13.9069 14.6632 12.2368 16.4305 10.0007 18.3333Z",
    fill: "#1C1B1F",
    fillOpacity: 0.4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationOn);
export default __webpack_public_path__ + "static/media/location_on.6343bcf4027151d49f0051c619c6eb3a.svg";
export { ForwardRef as ReactComponent };